import { defineMessage } from 'services/localization';

export const messages = {
    subscriptionExpires: defineMessage('the_organisation_expire_ilable_in_readonly_mode'),
    subscriptionExpiredLink: defineMessage('please_add_the_organisa_n_or_purchase_a_new_one'),
    retired: defineMessage('the_organisation_is_ret_ilable_in_readonly_mode'),
    trialExpiredAndReadonly: defineMessage('the_organisations_trial_ilable_in_readonly_mode'),
    expiredAndReadonly: defineMessage('the_organisations_subsc_ilable_in_readonly_mode'),
    subscribeAfterTrial: defineMessage('the_organisations_trial_your_financial_controls'),
    subscribeNow: defineMessage('subscribe_now'),
};
